import orderList from './orderList'
import orderTypeList from './orderTypeList'
import rolesList from './rolesList'
import statusList from './statusList'

export default [
  ...orderList,
  ...orderTypeList,
  {
    path: '/pvh/client/list',
    name: 'PvhClientList',
    component: () => import('@/views/Pvh/PvhClientList.vue')
  },
  {
    path: '/pvh/client/update/:id',
    name: 'PvhClientUpdate',
    component: () => import('@/views/Pvh/PvhClientUpdate.vue')
  },
  {
    path: '/pvh/delivery-types',
    name: 'PvhDeliveryTypeList',
    component: () => import('@/views/Pvh/PvhDeliveryTypeList.vue')
  },
  {
    path: '/pvh/inform-types',
    name: 'PvhInformTypeList',
    component: () => import('@/views/Pvh/PvhInformTypeList.vue')
  },
  ...rolesList,
  ...statusList,
  {
    path: '/pvh/cost-types',
    name: 'PvhCostTypeList',
    component: () => import('@/views/Pvh/PvhCostTypeList.vue')
  },
  {
    path: '/pvh/incoming-types',
    name: 'PvhIncomingTypeList',
    component: () => import('@/views/Pvh/PvhIncomingTypeList.vue')
  }
]
